// Though CmsVideo is a server component and this could be in the same file,
// it's separate to avoid circular dependency between PDP and course page.
export const cmsVideoFragment = `
  fragment cmsVideoFragment on VideoRecord {
    playMode
    video {
      alt
      video {
        ...videoFragment
      }
    }
  }
`;
